import { ProductType, Region, Zone } from './orderTypes';

export interface IntervalOrderCount {
  start: string;
  end: string;
  orderCount: { [key in ProductType]?: number };
}

export interface ZoneOrderCount {
  zone: Zone;
  orderCount: { [key in ProductType]?: number };
}

export interface OrderAndDeliveryCount {
  orderCount: number;
  deliveryCount: number;
  cachedDeliveryCount: number;
  cachedPrebookingsCount: number;
}

export interface RegionZoneIntervalOrderCount {
  region: Region;
  //key: product
  count: { [key in ProductType]?: OrderAndDeliveryCount };
  zoneOrderCounts: ZoneOrderCount[];
  intervals: IntervalOrderCount[];
  predictedParcelCount: number;
}

export interface RegionOrderCount {
  region: Region;
  orderCount: { [key in ProductType]?: number };
}

export interface WithRegion {
  region: Region;
}

export function associateByRegion<U extends WithRegion>(
  values: U[]
): { [key in Region]?: U } {
  const byRegion = {};
  values.forEach(value => {
    byRegion[value.region] = value;
  });
  return byRegion;
}

export interface DailyDeliveryOrdersSummary {
  ordersSizeCount: OrdersSizeCount;
  ordersBundlesCount: OrdersBundlesCount;
  accounts: OrdersAccountCount[];
}

export interface OrdersSizeCount {
  dailyTotal: number;
  xxl: number;
  temperatureCount: number;
}

export interface OrdersBundlesCount {
  openDeviationCount: number;
  bundleCount: number;
  openBundledDeviationCount: number;
}

export interface OrdersAccountCount {
  accountId: number;
  accountName: string;
  orderCount: number;
}

export interface DailyPickupsSummary {
  pickupDate: string;
  pickups: PickupsAccountCount[];
}

export interface PickupsAccountCount {
  accountId: number;
  accountName: string;
  orderCount: number;
  region: Region;
}

export interface ParcelsLineHaulCount {
  lineHaulId: number;
  lineHaulName: string;
  lineHaulFirstScan: string;
  lineHaulParcelsScansToDoForDate: number;
  lineHaulParcelsScansDoneForDate: number;
}
